;(function () {
  'use strict'

  angular
    .module('contrast.date')
    .controller('csDateRangePickerCtrl', [
      'TimeService',
      'csDateRangePickerFormats',
      csDateRangePickerCtrl
    ])

  function csDateRangePickerCtrl(TimeService, csDateRangePickerFormats) {
    var momentFormat = TimeService.getDateTimeFormat()

    var vm = this
    vm._show = false
    vm.datePickerOpts = {
      // Hide column that displays week number
      showWeeks: false,
      formatDayTitle: csDateRangePickerFormats.UIB_FORMAT_DAY_TITLE,
      formatDay: csDateRangePickerFormats.UIB_FORMAT_DAY,
      maxDate: new Date()
    }

    vm.activate = activate
    vm.setModel = setModel
    vm.cancel = cancel
    vm.apply = apply
    vm.show = show
    vm.shouldShow = shouldShow
    vm.hide = hide
    vm.startDateChanged = startDateChanged
    vm.endDateChanged = endDateChanged
    vm.startTimeChanged = startTimeChanged
    vm.endTimeChanged = endTimeChanged

    function activate() {
      _initModel()
      show()
    }

    function setModel(model) {
      vm.model.startDate = moment(model.startDate, momentFormat)
      vm.model.endDate = moment(model.endDate, momentFormat)
      vm.model.startTime = moment(model.startTime)
      vm.model.endTime = moment(model.endTime)
    }

    function _initModel() {
      // Init model - if already set, use that, otherwise, last week
      if (!angular.isObject(vm.model)) {
        var model = TimeService.getLastWeekLocalTimeZone()
        vm.model = {
          startDate: moment(model.startDate, momentFormat),
          endDate: moment(model.endDate, momentFormat)
        }
        // Create separate time values - this is recommended by the uib-timepicker docs
        vm.model.startTime = vm.model.startDate
        vm.model.endTime = vm.model.endDate
      }

      _initExtraOptions()
    }

    function _initExtraOptions() {
      if (
        vm.extraOptions &&
        angular.isArray(vm.extraOptions) &&
        vm.extraOptions.length == 2
      ) {
        vm.model.extraOptionsSelected = vm.extraOptions.find(function (o) {
          return o.default
        }).value
      }
    }

    function show() {
      vm._show = true
    }

    function hide() {
      vm._show = false
    }

    function shouldShow() {
      return vm._show === true && vm.model
    }

    function cancel() {
      if (vm.onCancel && angular.isFunction(vm.onCancel)) {
        vm.onCancel()
      }
      vm._show = false
    }

    function apply() {
      vm.propagateModelChange()
      vm._show = false
    }

    // Make sure new start date is not *after* current end date
    function startDateChanged(newVal, oldVal) {
      var a = moment(newVal)
      var b = moment(vm.model.endDate)
      vm.model.startDate = a.isAfter(b) ? moment(oldVal) : moment(newVal)
      vm.highlightDaysInRange()
    }

    // Make sure new end date is not *before* current start date
    function endDateChanged(newVal, oldVal) {
      var a = moment(newVal)
      var b = moment(vm.model.startDate)
      vm.model.endDate = a.isBefore(b) ? moment(oldVal) : moment(newVal)
      vm.highlightDaysInRange()
    }

    function startTimeChanged(newVal, oldVal) {
      // sync with dates
      var newStartSynced = _syncTimeToDate(newVal, 'start')
      var oldStartSynced = _syncTimeToDate(oldVal, 'start')
      var end = _syncTimeToDate(vm.model.endTime, 'end')

      // validate and set
      vm.model.startTime = newStartSynced.isAfter(end)
        ? oldStartSynced
        : newStartSynced
    }

    function endTimeChanged(newVal, oldVal) {
      // sync with dates
      var newEndSynced = _syncTimeToDate(newVal, 'end')
      var oldEndSynced = _syncTimeToDate(oldVal, 'end')
      var start = _syncTimeToDate(vm.model.startTime, 'start')

      // validate and set
      vm.model.endTime = newEndSynced.isBefore(start)
        ? oldEndSynced
        : newEndSynced
    }

    function _syncTimeToDate(time, which) {
      var dateKey = which + 'Date'
      time = moment(time)
      var date = moment(vm.model[dateKey]).startOf('day')
      var timeBegin = moment(time).startOf('day')
      var timeDiff = time.diff(timeBegin)
      date.add(Math.abs(timeDiff))
      return date
    }
  }
})()
